import styled from '@emotion/styled';

const Heading = styled.h3`
  color: #61afef;
  margin-bottom: 12px;
  margin-top: 35px;
`;

export default Heading;
